import { Site } from '@envato/foundation-types'

import { siteNames } from '../../common/constants/siteList'

/**
 * A util function to get the current site from request url
 * e.g themeforest.shopfront.envato.com, videohive.net
 * @return {string} site name
 */
function getCurrentSiteByUrl(url?: string) {
  if (!url) {
    throw new Error('url is required.')
  }

  let currentSite = Site.themeforest
  for (const site of siteNames) {
    if (url.indexOf(site) >= 0) {
      currentSite = site
      break
    }
  }

  return currentSite
}

export default getCurrentSiteByUrl
